module.exports = __webpack_public_path__ + "img/other.720094ae.svg";